import type { CSSProperties, HTMLAttributes } from 'react';

const SHIMMER_STYLE: CSSProperties = {
  backgroundImage:
    'linear-gradient(90deg, #D1D5DB 0%, #D8DCE2 50%, #D1D5DB 100%)',
  backgroundSize: '200% 100%',
};

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full' | 'none';
}

const roundedClass: Record<NonNullable<SkeletonProps['rounded']>, string> = {
  none: '',
  sm: 'rounded',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  '3xl': 'rounded-3xl',
  full: 'rounded-full',
};

export function Skeleton({ rounded = 'md', className = '', style, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={`bg-gray-300 animate-shimmer ${roundedClass[rounded]} ${className}`}
      style={{ ...SHIMMER_STYLE, ...style }}
      {...rest}
    />
  );
}
